import { DateTime } from 'luxon';
import React, { FC } from 'react';
import styled from 'styled-components';

import BaseCard, { IBaseCard } from '@ui/atoms/BaseCard';
import BasicText from '@ui/atoms/BasicText';
import FlexColumn from '@ui/atoms/FlexColumn';
import FlexRow from '@ui/atoms/FlexRow';

import padded from '@ui/styled/Padded';

import { getServiceDisplayName } from '@helpers/Appointments';

import { IAppointment } from '@folx-types/scheduledAppointments';

import theme from '@theme/FolxTheme';

const PaddedCard = padded<IBaseCard>(BaseCard);

const StyledText = styled(BasicText)`
	font-size: ${theme.fontSizes.body.xs};
`;

const SpacedRow = styled(FlexRow)`
	justify-content: space-between;
`;

const PastAppointmentCard: FC<IAppointment> = ({
	scheduledDt,
	staffMember,
	duration,
	visitType,
	serviceType,
}) => {
	const convertedDate = DateTime.fromISO(scheduledDt);
	const localizedTime = convertedDate?.toFormat('h:mm a ZZZZ');
	const localizedDateTime = `${convertedDate.toLocaleString(
		DateTime.DATE_MED
	)} at ${localizedTime}`;
	const visitInfo = `${duration} min ${visitType === 'irl' ? 'in-person' : 'virtual'} visit`;

	return (
		<PaddedCard shadow borderless bgColor="white" padding="sm" radius="md">
			<FlexColumn gap="sm">
				<SpacedRow gap="sm">
					<FlexColumn>
						<StyledText variant="field">{staffMember}</StyledText>
						<BasicText variant="fineprint">{visitInfo}</BasicText>
					</FlexColumn>
				</SpacedRow>
				<FlexColumn>
					<BasicText>{getServiceDisplayName(serviceType)}</BasicText>
					<StyledText variant="field">{localizedDateTime}</StyledText>
				</FlexColumn>
			</FlexColumn>
		</PaddedCard>
	);
};

export default PastAppointmentCard;
